import 'jquery';
import { UnifyMenu } from '@sop/unify-menu';
export class Menu {
    constructor(selector, json) {
        this.json = json;
        this.selector = selector;
    }

    init() {
        this.menu = new UnifyMenu(this.json, $(this.selector));
    }

    setActiveObject(json) {
        this.menu.setActiveMenuObject(json);
    }

    setActiveNode(json) {
        this.menu.setActiveMenuObject(json);
    }

    setActiveNodeById(json) {
        this.menu.setActiveMenuObjectById(json);
    }

    setActiveNodeByUri(json) {
        this.menu.setActiveMenuObjectByUri(json);
    }

}
